/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import i18n from "@/i18ns/i18n"

export default {
  requestNeedToDo: state => state.requestNeedToDo,
  requestMyCreate: state => state.requestMyCreate,
  requestMyExecute: state => state.requestMyExecute,
  userInfor: state => state.userInfor,
  // get giá trị cho cơ cấu tổ chức
  getDataOrganization: state => state.dataOrganization,
  // get giá trị cho cơ cấu tổ chức
  getDataOrganizationCommon: state => state.dataOrganizationCommon,
  // get giá trị cho cơ cấu tổ chức chứa đơn vị ngưng hoạt động
  getDataOrganizationCommonInactive: state =>
    state.dataOrganizationCommonInactive,
  getSelectedCount: state => state.selectedCount,
  // lấy danh sách quyền
  getListRole: state => state.listRole,
  //Lấy ra trạng thái mở cây của treelist
  getExpandedTreeList: state => state.expandedTreeList,
  //Lấy ra danh sách header bảng
  getGridConfig: state => state.gridConfig,
  getUserOptions: state => state.userOptions,
  //Lấy ra danh sách báo cáo
  lstReportMaster: state => state.lstReportMaster,
  listDataGrid: state => state.userInfor,

  // lấy ra danh sách Vị trí công việc
  getDataJobPosition: state => state.dataJobPosition,

  // lấy ra trạng thái load lại danh sách
  getStateLoadListProcess: state => state.stateLoadListProcess,
  // lấy ra ngwopfi thực hiện bước đầu tiên
  getExecutorFirstStep: state => state.executorFirstStep,
  // Lấy danh sách Grid theo từng subsytem - HCPHI
  getGridConfigUser: (state, getters) => (subSytemGrid, listModifyColumn) => {
    // * Nếu có trong UserOption thì gán vào gridconfig không thì gán giá trị mặc định
    if (getters.getUserOptions[subSytemGrid]) {
      const listGridHeader = getters.getUserOptions[subSytemGrid];

      // nvcuong1: xử lý trường hợp thay đổi useroption trong grid nhưng không muốn xóa bỏ lựa chọn trước đây của người dùng
      listModifyColumn.forEach(col => {
        if (col.SubSystemGrid === subSytemGrid) {
          // thêm cột
          if (col.ActionType === 1) {
            // nếu chưa có cột thì mới thêm
            const findRes = listGridHeader.findIndex(
              i => i.FieldName === col.ColumnOption.FieldName
            );
            // chưa có cột
            if (findRes === -1) {
              listGridHeader.splice(col.IndexPosition, 0, col.ColumnOption);
            }
          }
          // sửa cột
          else if (col.ActionType === 2 && listGridHeader[col.IndexPosition]) {
            listGridHeader[col.IndexPosition] = col.ColumnOption;
          }
          // xóa cột
          else if (col.ActionType === 3 && listGridHeader[col.IndexPosition]) {
            listGridHeader.splice(col.IndexPosition, 1);
          }
        }
      });
      listGridHeader.forEach(element => {
        if (element.KeyLanguage) {
          element.Caption = i18n.t(element.KeyLanguage);
        }
      });

      state.gridConfig[subSytemGrid] = listGridHeader;
      return state.gridConfig[subSytemGrid];
    } else {
      state.gridConfig[subSytemGrid] = state.gridConfigDefault[subSytemGrid];
      return state.gridConfig[subSytemGrid];
    }
  },
  // lấy danh sách status
  getProcesstStatus: state => state.listProcesstStatus,
  // lấy danh sách mức độ ưu tiên
  getProcesstPriority: state => state.listProcessPriority,

};
